import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';

import { useAffiliateByTicketingSlug } from 'queries/affiliate/useAffiliateByTicketingSlug';
import {
  useAffiliatePartner,
  useAffiliateStoreActions,
} from 'services/stores/affiliate/hooks';

export const useAffiliateWatcher = () => {
  const { query, isReady } = useRouter();

  /**
   * Store
   */
  const affiliatePartner = useAffiliatePartner();
  const affiliateStateAction = useAffiliateStoreActions();

  /**
   * Get the right affiliate Ticketing Slug.
   * -Compare if same as session. If same, return state.
   * -If different, priority to the query param.
   */
  const ticketingPartnerSlug = useMemo(() => {
    if (!isReady) return;

    //Priority to the query param if different from the state
    if (
      query.affiliate &&
      affiliatePartner?.ticketingPlatformSlug !== query.affiliate
    ) {
      return query.affiliate as string;
    }

    //Check current partner
    if (affiliatePartner?.ticketingPlatformSlug) {
      return affiliatePartner.ticketingPlatformSlug;
    }

    return query.affiliate as string;
  }, [isReady, affiliatePartner?.ticketingPlatformSlug, query.affiliate]);

  /**
   * Query
   */
  const AffiliateQuery = useAffiliateByTicketingSlug(ticketingPartnerSlug);

  /**
   * Watch for affiliate query and update the state
   */
  useEffect(() => {
    if (!isReady || AffiliateQuery.isLoading) return;

    if (AffiliateQuery.isSuccess) {
      /**
       * If not found affiliate, clean the state.
       */
      if (AffiliateQuery.affiliate === null) {
        affiliateStateAction.clean();

        return;
      }

      if (AffiliateQuery.affiliate) {
        affiliateStateAction.upsert(AffiliateQuery.affiliate);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isReady,
    AffiliateQuery.affiliate,
    AffiliateQuery.isSuccess,
    AffiliateQuery.isLoading,
  ]);

  return null;
};
